import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigApi {

  constructor() {
  }

  //Para pruebas locales se puede usar "api=/" con ng serve --proxy-config proxy.conf.json y evitar problemas de CORS
  //Cuando se apunta a backend local
  //api = '';
  //api = 'https://api-r360.qas.ransaaplicaciones.com';
  //api = 'https://api-r360-configuracion.sbx.ransaaplicaciones.com';

  // Pruebas
  // api = 'https://api-r360-sbx.sbx.ransaaplicaciones.com';
  
  // PRD
  api = 'https://api-r360.ransaaplicaciones.com';

  // Calidad
  // api = 'https://api-r360.qas.ransaaplicaciones.com';

  // apiAws = 'https://k5zjtzp7y6vhegrd7oepmjylda0vggyx.lambda-url.us-east-1.on.aws'; // sbx
  apiAws = 'https://6bohjze34k57zci4bu6qtwyev40ncugj.lambda-url.us-east-1.on.aws'; // prd
  // apiAws = 'https://xltwmyxkzwy2xyxmatyrsgak4q0hmsap.lambda-url.us-east-1.on.aws';//QAS

  // apiInv = 'https://mxc4b34kv4g4umoilmcmanckny0fgtnu.lambda-url.us-east-1.on.aws'; //QAS
  apiInv = 'https://ccr5fbihl3vfsx4qjetmnnn2740cinkx.lambda-url.us-east-1.on.aws'; // PRD


  BACKEND_URL = `${this.api}/menu?origen=web`;
  PEDIDOS_URL = `${this.apiAws}/pedido/resumen?fecha=`;
  LISTAPEDIDOS_URL = `${this.apiAws}/pedido/resumen/detalle?fecha=`;
  DETAILORDER_URL = `${this.apiAws}/pedido?`;
  CITAS_POR_HORA_URL= `${this.api}/citasPorHoras?`;
  EXPORTEXCEL = `${this.api}/exportEntregas?`;
  GENERALORDER_URL = `${this.api}/general_nuevo`;
  GETDETAILTRUCK = `${this.api}/vehiculo/`;
  LASTUPDATEDHOUR = `${this.api}/ultimaActualizacionGeneral`;
  GETICONCLIENTE = 'https://r360.ransa.net/logos/';
  GETPICKING = `${this.api}/picking/resumen/`;
  GETDETAILPICKING = `${this.api}/picking/detalle/`;
  EXPORTPICKING = `${this.api}/exportPicking?`;
  GET_DESCARGAS = `${this.api}/getDescargas?`;
  GET_DESCARGAURL = `${this.api}/getDescargaURL?`;
  GETPI = `${this.api}/picking/historial/`;
  GET_TEMPERATURE = `${this.api}/temperatura/`;
  GET_VIAJEPORFECHA = `${this.api}/viajePorFecha?fecha=`;
  GET_FOTOPORPARADA = `${this.apiAws}/pedido/fotoPorParada?`;

  GET_TOKENPOWERBI = `${this.api}/tokenPowerBI`;
  GET_REPORTESPOWERBI = `${this.api}/reportesPowerBI`;
  GET_PAGINACION= `${this.apiAws}/pedido?fecha=`;
  GET_PAGINACION_TCF= `${this.apiAws}/pedidoTCF?fecha=`;
  DT_TRACKING= `${this.api}`;
  //CONSULTA_VIAJE= `https://69l8k8rs77.execute-api.us-east-1.amazonaws.com/sbxnew`;
  CONSULTA_VIAJE= `${this.api}`; //`https://69l8k8rs77.execute-api.us-east-1.amazonaws.com/sbxnew`;
  DT_TRACKING_IMPORTACION= `${this.api}/dtImportacion`;
  DT_TRACKING_EXPORTACION= `${this.api}/dtExportacion`;
  GET_USER = ` ${this.api}`;
  EDITAR_COLUMNAS_AVANCE = `${this.api}/guardarPreferencia`;
  LISTAR_COLUMNAS_AVANCE = `${this.api}/listarPreferencia`;
  // LISTAR_COLUMNAS_AVANCE = `https://api-r360-sbx.sbx.ransaaplicaciones.com/listarPreferencia`;
  GET_ASBANCCONSULTAFACPENDIENTE = `${this.api}/asbancConsultaFacPendiente`;
  GET_ASBANCCONSULTACODIGOPAGO = `${this.api}/asbancConsultaCodigo`;
  POST_ASBANCGENERARCODIGO = `${this.api}/asbancGenerarCodigo`;
  EXPORT_DOC_POR_PAGAR = `${this.api}/exportarFacPendiente?`;
  GET_ASBANC_CONSULTA_FAC_ABONADAS = `${this.api}/asbancConsultaListFacAbonadas`;
  GET_ASBANC_CONSULTA_COD_VIGENTES = `${this.api}/asbancConsultaListCodPagoVigente`;
  GET_ASBANC_CONSULTA_FAC_DETALLES = `${this.api}/asbancListCodPagoVigenteDetalle`;
  GET_ASBANC_DELETE_COD_PAGO = `${this.api}/asbancEliminarCodPagoVigente`;
  GET_ASBANC_FAC_PDF_XML = `${this.api}/asbancGetFactPdfXml`;
  GET_ASBANC_FAC_ABONADAS = `${this.api}/asbancExportFacAbonadas`;
  GET_ASBANC_COD_PAGO_VIGENTE = `${this.api}/asbancExportCodPagoVigente`;
  GET_RESUMEN_INVENTARIO = `${this.apiInv}/inventario/resumen`;
  GET_LISTA_STOCK_INVENTARIO = `${this.apiInv}/inventario/listInvStock`;
  GET_LISTA_SKU_INVENTARIO = `${this.apiInv}/inventario/listInvSku`;
  GET_DETALLE_SKU_INVENTARIO = `${this.apiInv}/inventario/detalle`;
  REPROCESAR_INVENTARIO = `${this.api}/inventario/reprocesarData`;
  EXPORTINVENTARIO = `${this.api}/exportInventario?`
  EXPORTINVENTARIOSKU = `${this.api}/exportInventarioSku?`
  GET_PEDIDOSMONITOR = `${this.api}/monitorPedidos/getPedidosMonitor`
  SEND_PEDIDOSMONITOR = `${this.api}/monitorPedidos/sendPedidosMonitor`
  GET_CLIENTE = `${this.api}/clientes/`
  VALIDATE_LOGIN = `${this.api}/validateLogin?`

  GET_AUDIT_IDENTIFICADOR = `${this.api}/audit/identificador-index`;
  GET_AUDIT_INTEGRACION = `${this.api}/audit/integracion-index`;
  GET_AUDIT_PROCESO = `${this.api}/audit/proceso-index`;
}
